import { render } from "./AvatarSquare.vue?vue&type=template&id=3f994762"
import script from "./AvatarSquare.vue?vue&type=script&lang=js"
export * from "./AvatarSquare.vue?vue&type=script&lang=js"

import "./AvatarSquare.vue?vue&type=style&index=0&id=3f994762&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__